import React from 'react'
import { ChevronRight } from 'lucide-react'
import type { HubProject } from '../../../api/data360'
import ProjectHubActionLinks from './ProjectHubActionLinks'
import {
  MetaChip,
  PROJECT_HUB_LIST_TD_CLASS,
  PROJECT_HUB_META_CLASS,
  PROJECT_HUB_NAME_CLASS,
  PROJECT_HUB_ROW_HOVER,
  getHubProjectDisplayFields,
  handleRowKeyDown
} from './projectHubShared'

function ProjectHubListActions({
  projectId,
  className = ''
}: {
  projectId: string
  className?: string
}) {
  return (
    <div className={`flex items-center justify-end gap-1.5 ${className}`}>
      <ProjectHubActionLinks projectId={projectId} size="sm" />
      <ChevronRight className="h-4 w-4 shrink-0 text-heritage-grey transition-transform group-hover:translate-x-0.5" />
    </div>
  )
}

export default function ProjectHubListRow({
  project,
  onOpen
}: {
  project: HubProject
  onOpen: (project: HubProject) => void
}) {
  const { client, application, pipeSets } = getHubProjectDisplayFields(project)
  const actionProjectId = project.wpsShadowId || project.id

  const handleRowClick = () => {
    onOpen(project)
  }
  const handleRowKey = (e: React.KeyboardEvent<HTMLTableRowElement>) => {
    handleRowKeyDown(e, handleRowClick)
  }

  const categoriesTitle = application !== '—' ? application : undefined

  return (
    <tr
      data-testid={`project-hub-list-${actionProjectId || project.data360ProjectId}`}
      role="button"
      tabIndex={0}
      aria-label={`Open ${project.name}`}
      onClick={handleRowClick}
      onKeyDown={handleRowKey}
      className={`group cursor-pointer ${PROJECT_HUB_ROW_HOVER} hover:relative hover:z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blueprint-blue/40`}
    >
      <td className={PROJECT_HUB_LIST_TD_CLASS}>
        <span className={PROJECT_HUB_NAME_CLASS}>
          {project.name}
        </span>
      </td>
      <td className={`${PROJECT_HUB_LIST_TD_CLASS} ${PROJECT_HUB_META_CLASS}`}>{client}</td>
      <td
        className={`${PROJECT_HUB_LIST_TD_CLASS} ${PROJECT_HUB_META_CLASS}`}
        title={categoriesTitle}
      >
        {application}
      </td>
      <td className={PROJECT_HUB_LIST_TD_CLASS}>
        <MetaChip>{pipeSets}</MetaChip>
      </td>
      <td className={PROJECT_HUB_LIST_TD_CLASS}>
        {actionProjectId ? <ProjectHubListActions projectId={actionProjectId} /> : null}
      </td>
    </tr>
  )
}

export { ProjectHubListActions }
